import { Suspense, lazy } from 'react';
import { Outlet } from 'react-router-dom';

import LoadingScreen from '@src/components/loading-screen';
import { ROLES } from '@src/globals';
import Layout from '@src/layouts/dashboard/layout';
import AuthGuard from '@src/routes/components/auth-guard';
import paths from '@src/routes/routes';

import RoleGuard from '../components/role-guard';

const WelcomePage = lazy(() => import('@src/pages/welcome'));
const TextAnalysisPage = lazy(() => import('@src/pages/text-analysis'));
const DebunkedClaimsListPage = lazy(
  () => import('@src/pages/debunked-claims-list')
);
const DebunkedClaimsAddPage = lazy(
  () => import('@src/pages/debunked-claims-add')
);
const InvitationPage = lazy(() => import('@src/pages/user-invitation'));
const ProfilePage = lazy(() => import('@src/pages/profile'));
const UsersListPage = lazy(() => import('@src/pages/users-list'));

const mainRoutes = [
  {
    path: paths.dashboard.root, // Main root "/dashboard"
    element: (
      <AuthGuard>
        <Layout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </Layout>
      </AuthGuard>
    ),
    children: [
      {
        element: (
          <RoleGuard roles={[ROLES.USER, ROLES.ADMIN]}>
            <WelcomePage />
          </RoleGuard>
        ),
        index: true,
      },
      {
        path: paths.dashboard.textAnalysis,
        element: (
          <RoleGuard roles={[ROLES.USER, ROLES.ADMIN]}>
            <TextAnalysisPage />
          </RoleGuard>
        ),
      },
      {
        path: paths.dashboard.debunkedClaims.list,

        element: (
          <RoleGuard roles={[ROLES.USER, ROLES.ADMIN]}>
            <DebunkedClaimsListPage />
          </RoleGuard>
        ),
      },
      {
        path: paths.dashboard.debunkedClaims.add,

        element: (
          <RoleGuard roles={[ROLES.USER, ROLES.ADMIN]}>
            <DebunkedClaimsAddPage />
          </RoleGuard>
        ),
      },
      {
        path: paths.dashboard.userManagement.add,
        element: (
          <RoleGuard roles={[ROLES.ADMIN]}>
            <InvitationPage />
          </RoleGuard>
        ),
      },
      {
        path: paths.dashboard.profile,
        element: (
          <RoleGuard roles={[ROLES.USER, ROLES.ADMIN]}>
            <ProfilePage />
          </RoleGuard>
        ),
      },
      {
        path: paths.dashboard.userManagement.list,
        element: (
          <RoleGuard roles={[ROLES.ADMIN]}>
            <UsersListPage />
          </RoleGuard>
        ),
      },
    ],
  },
];

export default mainRoutes;
